var render = function render(){var _vm=this,_c=_vm._self._c;return _c('date-inputs',{key:_vm.filter.value,attrs:{"id":_vm.fKey,"placeholder":_vm.filter.text,"val":_vm.filter.value,"name":_vm.fKey,"lock-past-days":_vm.filter.lockPastDays,"lock-future-days":_vm.filter.lockFutureDays,"lock-range-days-number":_vm.filter.lockRangeDaysNumber},on:{"change":function($event){return _vm.$emit('set-filter', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }